import React from "react";

const STYLES = {
    completed: "bg-mint-50 text-mint-700 border-mint-200",
    in_progress: "bg-sky-50 text-sky-700 border-sky-200",
    assigned: "bg-violet-50 text-violet-700 border-violet-200",
    requested: "bg-amber-50 text-amber-700 border-amber-200",
    cancelled: "bg-red-50 text-red-700 border-red-200",
    approved: "bg-mint-50 text-mint-700 border-mint-200",
    rejected: "bg-red-50 text-red-700 border-red-200",
    pending: "bg-amber-50 text-amber-700 border-amber-200",
    open: "bg-amber-50 text-amber-700 border-amber-200",
    resolved: "bg-mint-50 text-mint-700 border-mint-200",
    closed: "bg-slate-100 text-slate-600 border-slate-200",
    urgent: "bg-red-50 text-red-700 border-red-200",
    high: "bg-orange-50 text-orange-700 border-orange-200",
    medium: "bg-amber-50 text-amber-700 border-amber-200",
    low: "bg-slate-100 text-slate-600 border-slate-200",
    active: "bg-mint-50 text-mint-700 border-mint-200",
    inactive: "bg-slate-100 text-slate-500 border-slate-200",
};

export const StatusBadge = ({ status, label, className = "" }) => {
    const key = (status || "").toLowerCase();
    const style = STYLES[key] || "bg-slate-100 text-slate-700 border-slate-200";
    return (
        <span
            className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border ${style} ${className}`}
            data-testid={`status-badge-${key}`}
        >
            {label || status?.replace(/_/g, " ")}
        </span>
    );
};

export default StatusBadge;
